import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
    CreateOrganizationChecklistDto,
    GetOrganizationChecklistDto,
    UpdateOrganizationChecklistDto,
} from '../interfaces/checklists';
import { CreateDefaultChecklistDto } from '../interfaces/checklists/create-default-checklist-dto.interface';
import { GetDefaultChecklistDto } from '../interfaces/checklists/get-default-checklist-dto.interface';
import { UpdateDefaultChecklistDto } from '../interfaces/checklists/update-default-checklist-dto.interface';

export const OrganizationChecklistActions = createActionGroup({
    source: 'Organization Checklist',
    events: {
        'Load Organization Checklists': emptyProps(),
        'Load Organization Checklists Success': props<{ checklists: GetOrganizationChecklistDto[] }>(),
        'Load Organization Checklists Failure': props<{ error: HttpErrorResponse }>(),

        'Create Checklist': props<{ createChecklistDto: CreateOrganizationChecklistDto }>(),
        'Create Checklist Success': props<{ checklist: GetOrganizationChecklistDto }>(),
        'Create Checklist Failure': props<{ error: any }>(),

        'Update Checklist': props<{ id: string; updateChecklistDto: UpdateOrganizationChecklistDto }>(),
        'Update Checklist Success': props<{ checklist: GetOrganizationChecklistDto }>(),
        'Update Checklist Failure': props<{ error: HttpErrorResponse }>(),

        'Load Checklist By Id': props<{ id: string }>(),
        'Load Checklist By Id Success': props<{ checklist: GetOrganizationChecklistDto }>(),
        'Load Checklist By Id Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Checklists': props<{ ids: string[] }>(),
        'Delete Checklists Success': props<{ ids: string[] }>(),
        'Delete Checklists Failure': props<{ error: HttpErrorResponse }>(),
    },
});

export const DefaultChecklistActions = createActionGroup({
    source: 'Default  Checklist',
    events: {
        'Load Checklists': emptyProps(),
        'Load Checklists Success': props<{ checklists: GetDefaultChecklistDto[] }>(),
        'Load Checklists Failure': props<{ error: HttpErrorResponse }>(),

        'Load Checklist By Id': props<{ id: string }>(),
        'Load Checklist By Id Success': props<{ checklist: GetDefaultChecklistDto }>(),
        'Load Checklist By Id Failure': props<{ error: HttpErrorResponse }>(),

        'Create Checklist': props<{ createDefaultChecklistDto: CreateDefaultChecklistDto }>(),
        'Create Checklist Success': props<{ checklist: GetDefaultChecklistDto }>(),
        'Create Checklist Failure': props<{ error: HttpErrorResponse }>(),

        'Update Checklist': props<{ id: string; updateDefaultChecklistDto: UpdateDefaultChecklistDto }>(),
        'Update Checklist Success': props<{ checklist: GetDefaultChecklistDto }>(),
        'Update Checklist Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Checklists': props<{ ids: string[] }>(),
        'Delete Checklists Success': props<{ ids: string[] }>(),
        'Delete Checklists Failure': props<{ error: HttpErrorResponse }>(),

        'Get Checklists For Translations': props<{ locales: string[]; untranslatedOnly: boolean }>(),
        'Get Checklists For Translations Success': props<{ data: Partial<GetDefaultChecklistDto[]> }>(),
        'Get Checklists For Translations Failure': props<{ error: HttpErrorResponse }>(),

        'Update Checklist Translation': props<{ checklists: Partial<GetDefaultChecklistDto>[] }>(),
        'Update Checklist Translation Success': props<{ checklists: Partial<GetDefaultChecklistDto>[] }>(),
        'Update Checklist Translation Failure': props<{ error: HttpErrorResponse }>(),
    },
});
